import React from "react";
import {useTranslation} from "react-i18next";
import InputAdornment from "@mui/material/InputAdornment";
import MDInput from "../../../materialDashboard/components/MDInput";
import { getIn } from 'formik';
import {preventValueChangeOnScroll} from "../../../utils/input";


const IncidentField = ({name, formik, unitOfMeasure, ...props}) => {
    const {t} = useTranslation(['incidents']);

    const value = getIn(formik.values, name) ?? "";
    const error = getIn(formik.errors, name);
    const touched = getIn(formik.touched, name);

    return <MDInput name={name}
                    label={t(`incidentForm.${name}`)}
                    value={value}
                    onChange={formik.handleChange}
                    error={touched && Boolean(error)}
                    helperText={touched && error}
                    variant="standard"
                    fullWidth
                    onWheel={preventValueChangeOnScroll}
                    InputProps={{
                        endAdornment: <InputAdornment position="end" disableTypography>{unitOfMeasure}</InputAdornment>,
                    }}
                    {...props} />
}

export default IncidentField;